interface LocationHours {
    monday: string
    tuesday: string
    wednesday: string
    thursday: string
    friday: string
    saturday: string
    sunday: string
}

export interface LocationConfig {
    city: string
    street: string
    cityState: string
    phone: string
    path: string
    route: string
    meta: {
        title: string
        subtitle: string
        description: string
        googleMaps: string
        coordinates: {
            lat: number
            lng: number
        }
        hours: LocationHours
    }
}

export const shopHours: LocationHours = {
    monday: '8:00 AM - 6:00 PM',
    tuesday: '8:00 AM - 6:00 PM',
    wednesday: '8:00 AM - 6:00 PM',
    thursday: '8:00 AM - 6:00 PM',
    friday: '8:00 AM - 6:00 PM',
    saturday: '8:00 AM - 3:00 PM',
    sunday: 'Closed'  
}

export const locations: LocationConfig[] = [
    {
        city: 'Orange',
        street: '1202 N Glassell St.',
        cityState: 'Orange, CA 92867',
        phone: '714-639-6460',
        path: '/locations/orange',
        route: 'orange-location',
        meta: {
            title: 'Plaza Muffler & Hitch Orange | Muffler Shop & Trailer Hitches',
            subtitle: 'Your trusted muffler shop and trailer hitch installer in Orange, CA since 1978',
            description: `Orange's trusted muffler shop at 1202 N Glassell St. Professional catalytic converter repair, custom exhaust systems & trailer hitch installation. Same-day service by certified technicians since 1978.`,
            googleMaps: 'https://g.co/kgs/qDjfmnS',
            coordinates: {
                lat: 33.808263322180736,
                lng: -117.85358479213318
            },
            hours: shopHours
        }
    },
    {
        city: 'Westminster',
        street: '6571 Westminster Blvd',
        cityState: 'Westminster, CA 92683',
        phone: '714-891-4050',
        path: '/locations/westminster',
        route: 'westminster-location',
        meta: {
            title: 'Plaza Muffler & Hitch Westminster | Muffler Shop & Trailer Hitches',
            subtitle: 'Professional muffler and trailer hitch installation in Westminster',
            description: 'Westminster muffler shop at 13282 Goldenwest. Expert catalytic converter repair, custom exhaust & trailer hitch installation. Same-day service by certified technicians. Family owned & operated.',
            googleMaps: 'https://maps.app.goo.gl/tu98UjrTqNC2xYGK8',
            coordinates: {
                lat: 33.76960560931029,
                lng: -118.00635898843566
            },
            hours: shopHours
        }
    },
    {
        city: 'Santa Ana',
        street: '701 East First Street',
        cityState: 'Santa Ana, CA 92701',
        phone: '714-547-0202',
        path: '/locations/santa-ana',
        route: 'santa-ana-location',
        meta: {
            title: 'Plaza Muffler & Hitch Santa Ana | Muffler Shop & Trailer Hitches',
            subtitle: 'Santa Ana\'s premier muffler shop and trailer hitch installer',
            description: 'Santa Ana muffler shop at 701 East First Street. Professional catalytic converter repair, custom exhaust & trailer hitch installation. Same-day service by certified technicians. Se habla español.',
            googleMaps: 'https://maps.app.goo.gl/BCSqdNLD8ywJVmUT7',
            coordinates: {
                lat: 33.745942822786745,
                lng: -117.86147101912186
            },
            hours: shopHours
        }
    }
];

export const getLocationByCity = (city: string | undefined): LocationConfig | undefined => {
    if (!city) return undefined;
    const search = city.toLowerCase();
    return locations.find(location => 
        location.city.toLowerCase() === search || 
        location.path.toLowerCase().endsWith(`/${search}`)
    );
};

export const generateLocationNavItems = () =>
    locations.map(({ city, path }) => ({
        name: city.toLowerCase(),
        label: city,
        to: path
    }));